/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { Track } from 'twilio-video';
import { usePublications } from '../../../../hooks/videoProvider/usePublications';
import { useVideoContext } from '../../../../contexts/videoProvider/videoContext';
import { Publication } from '@components/videoProvider/twilio/Publication/Publication';

export namespace ParticipantTracks {
  export interface Props {
    participant: VideoProvider.IParticipant;
    isDominantSpeaker?: boolean;
    videoPriority?: Track.Priority | null;
  }
}

export const ParticipantTracks: React.FunctionComponent<ParticipantTracks.Props> = ({
  participant,
  isDominantSpeaker,
  videoPriority,
}) => {
  const { room } = useVideoContext();
  const publications = usePublications(participant);
  const isLocal = participant === room?.localParticipant;
  const filteredPublications = publications.filter(p => p.trackName !== 'screen');
  return (
    <>
      {filteredPublications.map((publication, i) => (
        <Publication
          key={i}
          isDominantSpeaker={isDominantSpeaker}
          publication={publication}
          participant={participant}
          isLocal={isLocal}
          videoPriority={videoPriority}
        />
      ))}
    </>
  );
};
